import * as actionTypes from '../actions';
import { PURGE, REHYDRATE } from 'redux-persist';

import set from 'lodash/fp/set';

const initialState = {
  user: {},
  loggedIn: false,
  login_detail: {},
  sessionsRefetched: null,
};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE: // This added just to show that this action type also exists, can be omitted.
      return state;

    case PURGE: // This added just to show that this action type also exists, can be omitted.
      return initialState;

    case actionTypes.SESSION_LOGIN: {
      return {
        ...state,
        loggedIn: true,
        user: action.payload,
      };
    }

    case actionTypes.SESSION_LOGIN_DETAIL: {
      return {
        ...state,
        login_detail: action.payload,
      };
    }

    case actionTypes.SESSION_LOGOUT: {
      return {
        ...state,
        loggedIn: false,
        user: {},
      };
    }

    case actionTypes.UPDATE_USER: {
      return set('user', { ...state.user, ...action.payload }, state);
    }

    case actionTypes.SESSIONS_REFETCHED: {
      return {
        ...state,
        sessionsRefetched: new Date(),
      };
    }

    default: {
      return state;
    }
  }
};

export default sessionReducer;
